import { render, staticRenderFns } from "./messageFormat.vue?vue&type=template&id=b8b0e624&scoped=true"
import script from "./messageFormat.vue?vue&type=script&lang=js"
export * from "./messageFormat.vue?vue&type=script&lang=js"
import style0 from "./messageFormat.vue?vue&type=style&index=0&id=b8b0e624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b0e624",
  null
  
)

export default component.exports